var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelfTestImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 63,
    viewBox: "0 0 41 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 20.5C4 11.3873 11.3873 4 20.5 4C29.6127 4 37 11.3873 37 20.5C37 29.6127 29.6127 37 20.5 37C11.3873 37 4 29.6127 4 20.5ZM20.5 0C9.17816 0 0 9.17816 0 20.5C0 27.2335 3.24642 33.2088 8.25946 36.946L5.01832 60.7299C4.915 61.4881 5.25329 62.2387 5.88971 62.6635C6.52613 63.0883 7.34912 63.1127 8.00962 62.7265L20.5 55.4221L32.9904 62.7265C33.6508 63.1127 34.4738 63.0883 35.1102 62.6636C35.7466 62.2389 36.0849 61.4883 35.9817 60.7302L32.7438 36.9436C37.755 33.2062 41 27.2321 41 20.5C41 9.17816 31.8218 0 20.5 0ZM29.0081 39.1566C26.4165 40.3403 23.5353 41 20.5 41C17.4659 41 14.5858 40.3409 11.995 39.158L9.53635 57.1999L19.4904 51.3788C20.1141 51.0141 20.886 51.0141 21.5096 51.3788L31.4643 57.2003L29.0081 39.1566Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfTestImage);
export default __webpack_public_path__ + "static/media/self-test-image.e87933e0ce7ef479fc08cb60d22df12f.svg";
export { ForwardRef as ReactComponent };